module.exports = __webpack_public_path__ + "static/media/intro_background.00732066.png";